import { render, staticRenderFns } from "./FormularioRotaComponent.vue?vue&type=template&id=0159b4ab"
import script from "./FormularioRotaComponent.vue?vue&type=script&lang=js"
export * from "./FormularioRotaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports